// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rcti-eligibility-stack {
  display: grid;
  gap: var(--space-5);
  min-width: 0;
}
.rcti-evidence-checks {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: var(--space-5);
}
.rcti-evidence-checks li {
  display: grid;
  gap: var(--space-3);
  border-bottom: 1px solid var(--border-subtle);
  padding-bottom: var(--space-5);
}
.rcti-evidence-checks li:last-child {
  border: 0;
  padding-bottom: 0;
}
.rcti-evidence-checks li > div {
  display: flex;
  justify-content: space-between;
  gap: var(--space-3);
  align-items: start;
}
.rcti-evidence-status {
  font-size: var(--font-size-caption-md);
  color: var(--success-text);
  white-space: nowrap;
  background: var(--success-soft);
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-sm);
}
.rcti-evidence-status.is-blocked {
  color: var(--danger-text);
  background: var(--danger-soft);
}
.rcti-review-workspace .rcti-evidence-edit {
  padding: 0;
  background: transparent;
  color: var(--interactive-default);
  justify-self: start;
  text-align: left;
  border: 0;
  min-height: 24px;
}
.rcti-evidence-checks a {
  color: var(--interactive-default);
  font-size: var(--font-size-body-sm);
}
.rcti-review-summary {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: var(--space-4);
  margin: 0;
  font-size: var(--font-size-body-sm);
}
.rcti-review-summary dt {
  color: var(--text-secondary);
}
.rcti-review-summary dd {
  text-align: right;
  margin: 0;
  overflow-wrap: anywhere;
}
.rcti-eligibility-footer {
  grid-column: 1 / -1;
  display: flex;
  justify-content: space-between;
  gap: var(--space-4);
  padding-top: var(--space-5);
  border-top: 1px solid var(--border-default);
}
.rcti-review-workspace .rcti-eligibility-footer button {
  display: inline-flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 12px;
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary);
  color: var(--text-primary);
  font: normal 500 13px/normal var(--font-family-primary, "Lexend", sans-serif);
}
.rcti-review-workspace .rcti-eligibility-footer .primary {
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
}
.rcti-adjustment-comparison {
  display: grid;
  gap: var(--space-5);
  min-width: 0;
}
.rcti-adjustment-comparison > div:first-child {
  display: grid;
  gap: var(--space-3);
}
.rcti-comparison-scroll {
  overflow-x: auto;
  max-width: 100%;
}
.rcti-comparison-scroll table {
  border-collapse: collapse;
  width: 100%;
  font-size: var(--font-size-body-sm);
}
.rcti-comparison-scroll caption {
  text-align: left;
  color: var(--text-secondary);
  padding-bottom: var(--space-3);
}
.rcti-comparison-scroll :is(th, td) {
  padding: var(--space-3);
  border-bottom: 1px solid var(--border-subtle);
  text-align: right;
  white-space: nowrap;
}
.rcti-comparison-scroll th:first-child {
  text-align: left;
}
.rcti-comparison-scroll thead {
  background: var(--surface-secondary);
  color: var(--text-secondary);
}
.rcti-comparison-scroll tbody tr:last-child {
  font-weight: var(--font-weight-semibold);
}
.rcti-adjustment-preview {
  padding: var(--space-5);
  border-bottom: 1px solid var(--border-default);
  background: var(--surface-secondary);
}
@media (max-width: 600px) {
  .rcti-evidence-checks li > div {
    flex-direction: column;
  }
  .rcti-eligibility-footer {
    flex-wrap: wrap;
  }
  .rcti-review-summary {
    grid-template-columns: 1fr;
    gap: var(--space-2);
  }
  .rcti-review-summary dd {
    text-align: left;
  }
}
.rcti-review-context {
  font-size: var(--font-size-body-sm);
  margin-bottom: var(--space-5);
  color: var(--text-secondary);
}
.rcti-review-workspace.rcti-communication-backdrop {
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}
.rcti-review-workspace .rcti-communication-dialog {
  height: 100%;
  max-height: 100%;
}
.rcti-review-workspace .rcti-evidence-checks p,
.rcti-review-workspace .rcti-eligibility-stack p {
  font-size: var(--font-size-body-sm);
  line-height: 1.6;
}
.rcti-review-workspace .rcti-evidence-checks strong {
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-body-md);
}

.rcti-comparison-scroll table :is(th, td) {
  color: var(--text-primary);
}
.rcti-comparison-scroll table thead th {
  color: var(--text-secondary);
}
/* A document-review workspace keeps the shell visible; the modal lock retains inert navigation. */
html[data-modal-background-locked]:has(.rcti-review-workspace) :is(.dashboard-nav, .app-topbar) { filter:none; }
`, "",{"version":3,"sources":["webpack://./src/layouts/RCTI/rctiJourney.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6CAA6C;EAC7C,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,sCAAsC;EACtC,0BAA0B;EAC1B,mBAAmB;EACnB,+BAA+B;EAC/B,sCAAsC;EACtC,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,uBAAuB;EACvB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,SAAS;EACT,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;AAC7C;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,uCAAuC;EACvC,qCAAqC;EACrC,kCAAkC;EAClC,0BAA0B;EAC1B,6EAA6E;AAC/E;AACA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,6CAA6C;EAC7C,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,uBAAuB;EACvB,8CAA8C;EAC9C,oCAAoC;AACtC;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,4BAA4B;AAC9B;AACA,kGAAkG;AAClG,kGAAkG,WAAW,EAAE","sourcesContent":[".rcti-eligibility-stack {\n  display: grid;\n  gap: var(--space-5);\n  min-width: 0;\n}\n.rcti-evidence-checks {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  gap: var(--space-5);\n}\n.rcti-evidence-checks li {\n  display: grid;\n  gap: var(--space-3);\n  border-bottom: 1px solid var(--border-subtle);\n  padding-bottom: var(--space-5);\n}\n.rcti-evidence-checks li:last-child {\n  border: 0;\n  padding-bottom: 0;\n}\n.rcti-evidence-checks li > div {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--space-3);\n  align-items: start;\n}\n.rcti-evidence-status {\n  font-size: var(--font-size-caption-md);\n  color: var(--success-text);\n  white-space: nowrap;\n  background: var(--success-soft);\n  padding: var(--space-1) var(--space-2);\n  border-radius: var(--radius-sm);\n}\n.rcti-evidence-status.is-blocked {\n  color: var(--danger-text);\n  background: var(--danger-soft);\n}\n.rcti-review-workspace .rcti-evidence-edit {\n  padding: 0;\n  background: transparent;\n  color: var(--interactive-default);\n  justify-self: start;\n  text-align: left;\n  border: 0;\n  min-height: 24px;\n}\n.rcti-evidence-checks a {\n  color: var(--interactive-default);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-review-summary {\n  display: grid;\n  grid-template-columns: 1fr 1.5fr;\n  gap: var(--space-4);\n  margin: 0;\n  font-size: var(--font-size-body-sm);\n}\n.rcti-review-summary dt {\n  color: var(--text-secondary);\n}\n.rcti-review-summary dd {\n  text-align: right;\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n.rcti-eligibility-footer {\n  grid-column: 1 / -1;\n  display: flex;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding-top: var(--space-5);\n  border-top: 1px solid var(--border-default);\n}\n.rcti-review-workspace .rcti-eligibility-footer button {\n  display: inline-flex;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  font: normal 500 13px/normal var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.rcti-review-workspace .rcti-eligibility-footer .primary {\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n}\n.rcti-adjustment-comparison {\n  display: grid;\n  gap: var(--space-5);\n  min-width: 0;\n}\n.rcti-adjustment-comparison > div:first-child {\n  display: grid;\n  gap: var(--space-3);\n}\n.rcti-comparison-scroll {\n  overflow-x: auto;\n  max-width: 100%;\n}\n.rcti-comparison-scroll table {\n  border-collapse: collapse;\n  width: 100%;\n  font-size: var(--font-size-body-sm);\n}\n.rcti-comparison-scroll caption {\n  text-align: left;\n  color: var(--text-secondary);\n  padding-bottom: var(--space-3);\n}\n.rcti-comparison-scroll :is(th, td) {\n  padding: var(--space-3);\n  border-bottom: 1px solid var(--border-subtle);\n  text-align: right;\n  white-space: nowrap;\n}\n.rcti-comparison-scroll th:first-child {\n  text-align: left;\n}\n.rcti-comparison-scroll thead {\n  background: var(--surface-secondary);\n  color: var(--text-secondary);\n}\n.rcti-comparison-scroll tbody tr:last-child {\n  font-weight: var(--font-weight-semibold);\n}\n.rcti-adjustment-preview {\n  padding: var(--space-5);\n  border-bottom: 1px solid var(--border-default);\n  background: var(--surface-secondary);\n}\n@media (max-width: 600px) {\n  .rcti-evidence-checks li > div {\n    flex-direction: column;\n  }\n  .rcti-eligibility-footer {\n    flex-wrap: wrap;\n  }\n  .rcti-review-summary {\n    grid-template-columns: 1fr;\n    gap: var(--space-2);\n  }\n  .rcti-review-summary dd {\n    text-align: left;\n  }\n}\n.rcti-review-context {\n  font-size: var(--font-size-body-sm);\n  margin-bottom: var(--space-5);\n  color: var(--text-secondary);\n}\n.rcti-review-workspace.rcti-communication-backdrop {\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n}\n.rcti-review-workspace .rcti-communication-dialog {\n  height: 100%;\n  max-height: 100%;\n}\n.rcti-review-workspace .rcti-evidence-checks p,\n.rcti-review-workspace .rcti-eligibility-stack p {\n  font-size: var(--font-size-body-sm);\n  line-height: 1.6;\n}\n.rcti-review-workspace .rcti-evidence-checks strong {\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-body-md);\n}\n\n.rcti-comparison-scroll table :is(th, td) {\n  color: var(--text-primary);\n}\n.rcti-comparison-scroll table thead th {\n  color: var(--text-secondary);\n}\n/* A document-review workspace keeps the shell visible; the modal lock retains inert navigation. */\nhtml[data-modal-background-locked]:has(.rcti-review-workspace) :is(.dashboard-nav, .app-topbar) { filter:none; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
